import React from 'react'

import { Row, Box } from 'components/_new/layout'
import { SvgName, SvgColor, Svg } from 'components/_new/ui'
import Text from 'components/_new/typography/Text/Text'

import s from './Alert.scss'


type AlertProps = {
  title?: ReactIntlMessage | string
  text?: ReactIntlMessage | string
  iconName?: SvgName
  iconColor?: SvgColor
}

const Alert: React.FunctionComponent<AlertProps> = (props) => {
  const { title, text, iconName = 'happyBird', iconColor = 'brand-30' } = props

  return (
    <Row>
      {
        Boolean(iconName) && (
          <Box className={s.iconContainer} mr={16}>
            <Svg name={iconName} color={iconColor} className={s.icon} />
          </Box>
        )
      }
      <div className={s.content}>
        {
          Boolean(title) && (
            <Text size="16-20" color="brand" semibold message={title} />
          )
        }
        {
          Boolean(text) && (
            <Box mt={8}>
              <Text size="16-20" message={text} />
            </Box>
          )
        }
      </div>
    </Row>
  )
}


export default Alert
